import React from "react";
import { Card, Button, Breadcrumb, Col, Divider, Row, Typography } from "antd";
import { Link } from "react-router-dom";

const style = {
  //background: "#0092ff",
  padding: "32px",
};

const gridStyle = {
  width: "300px",
  textAlign: "center",
};
const App = () => (
  <Card
    title={
      <Breadcrumb
        items={[
          {
            title: "Beranda",
          },

          {
            title: "Kontak Kami",
          },
        ]}
      />
    }
  >
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
        lg: 32,
      }}
    >
      <Col className="gutter-row" span={4}>
        <Row align="center" style={{ height: "100%", alignItems: "center" }}>
          <Col align="center">
            <Link to="https://www.big.go.id" target="_blank">
              <img
                src={process.env.PUBLIC_URL + "/static/images/logobig.png"}
                alt="Logo BIG"
                style={{ maxWidth: "100px" }}
              />
            </Link>
          </Col>
        </Row>
      </Col>
      <Col className="gutter-row" span={8}>
        <Typography.Title level={4} style={{ marginBottom: "16px" }}>
          Kontak Kami
        </Typography.Title>
        Direktorat Standar dan Teknologi Informasi Geospasial <br />
        Badan Informasi Geospasial <br />
        JL. Raya Jakarta - Bogor KM 46, Cibinong 16911 <br />
        Tlp.021-8753155 atau 021-8752062 ext. 3608/3611/3103 <br />
        Fax. 021-87908988/8753155 <br />
        Email. info@big.go.id <br />
        <Row justify="start" style={{ marginTop: "20px" }}>
          <Col>
            <Link to="https://www.facebook.com/infogeospasial" target="_blank">
              <img
                src={process.env.PUBLIC_URL + "/static/images/facebook.png"}
                alt="Logo facebook"
                style={{ maxWidth: "80%" }}
              />
            </Link>
          </Col>
          <Col>
            <Link to="https://twitter.com/@InfoGeospasial" target="_blank">
              <img
                src={process.env.PUBLIC_URL + "/static/images/twitter.png"}
                alt="Logo Twitter"
                style={{ maxWidth: "80%" }}
              />
            </Link>
          </Col>
          <Col>
            <Link to="https://www.instagram.com/infogeospasial" target="_blank">
              <img
                src={process.env.PUBLIC_URL + "/static/images/instagram.png"}
                alt="Logo Instagram"
                style={{ maxWidth: "80%" }}
              />
            </Link>
          </Col>
          <Col>
            <Link
              to="https://www.youtube.com/@BadanInformasiGeospasial1969"
              target="_blank"
            >
              <img
                src={process.env.PUBLIC_URL + "/static/images/youtube.png"}
                alt="Logo Youtube"
                style={{ maxWidth: "80%" }}
              />
            </Link>
          </Col>
        </Row>
      </Col>
      <Col className="gutter-row" span={8}>
        <Typography.Title level={4} style={{ marginBottom: "16px" }}>
          Jam Operasional
        </Typography.Title>
        Senin - Jum'at, Pukul 08.00-16.00 WIB <br />
        <Typography.Title level={4} style={{ marginBottom: "16px" }}>
          Ina-Geoportal mendukung program:
        </Typography.Title>
        <Row
          justify="space-around"
          style={{ marginTop: "20px", alignItems: "center" }}
        >
          <Col>
            <Link to="https://data.go.id" target="_blank">
              <img
                src={process.env.PUBLIC_URL + "/static/images/sdi.png"}
                alt="Logo SDI"
                style={{ maxWidth: "120px" }}
              />
            </Link>
          </Col>
          <Col>
            <img
              src={process.env.PUBLIC_URL + "/static/images/logo_wbk.png"}
              alt="Logo WBK"
              style={{ maxWidth: "80px" }}
            />
          </Col>
          <Col>
            <Link
              to="https://sippn.menpan.go.id/pelayanan-publik/8232623/deputi-bidang-infrastruktur-informasi-geospasial/aplikasi-penghubung-simpul-jaringan-informasi-geospasial-di-pusat-ppig-big-ina-geoportal"
              target="_blank"
            >
              <img
                src={
                  process.env.PUBLIC_URL + "/static/images/logo-cariyanlik.svg"
                }
                alt="Logo Cari Yan"
                style={{ maxWidth: "150px" }}
              />
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  </Card>
);
export default App;
